<template>
  <div class="h-full bg-documentGray">
    <TopAppBar
        :leftBtnMethod="leftBtnMethod"
        :leftBtnMode="leftBtnMode"
        :rightBtnMethod="rightBtnMethod"
        :rightBtnMode="rightBtnMode"
        :title="title"
        :hideCategory="false"
        staticMode="true"
    >
    </TopAppBar>
    <div class="d-flex flex-column">
      <TopAppBarDrawer
          :isDrawerOpen="isDrawerOpen"
          @closeDrawer="closeDrawer"
      ></TopAppBarDrawer>

      <main class="main-wrapper flex-grow-1 bg-documentGray">
        <div :style="showing" class="d-flex align-items-center bg-white fix-header-title">
          <div
              class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex align-items-center justify-content-center">
            {{ categoryList.name }}
          </div>
          <div class="mgr-24 right-button">
            <button class="mdc-icon-button" tabindex="0" @click="searchOpen" @keypress="searchOpen"><i
                class="material-icons ">search</i></button>
          </div>
        </div>
        <div :style="hiding" class="searchbar bg-white fix-header-title-community fix-header-title">
          <div class="d-flex flex-grow-1  align-items-center pdt-6 pdb-6">
            <div class="d-flex flex-grow-1 pdl-12">
              <i class="material-icons search_form_close mdc-icon-button  js--dropdown-toggle"
                 tabindex="0" @click="searchClose();" @keypress="searchClose();">close</i>
              <input v-model="contents"
                     :placeholder="$t('3125')"
                     autofocus
                     class="search_form w-full pdl-8 t-color-headlineBlack border-none t-headline8 cursor-blue"
                     type="text"
                     @keyup="getStoreSerach"/>
            </div>
            <div class="mgr-24 right-button">
              <i class="material-icons mdc-icon-button t-headline6 js--dropdown-toggle" tabindex="0" @click="search();" @keypress="search();">search</i>
            </div>
          </div>
        </div>
        <div class="divider"></div>

        <div class="container container--narrow pdt-30">
          <div v-if="isAllHide === true" class="t-headline7 font-m l-spacing72 t-line-h-36">{{ $t('3165') }}</div>
          <div v-else class="t-headline7 font-m l-spacing72 t-line-h-36">{{ categoryName }}</div>
          <div class="pdb-8 pdr-8 pdt-8">
            <div class="mdc-chip-set banner--chip chip--outlined top-chip pdl-0" role="grid">
              <div role="row" tabindex="0" v-bind:class="['mdc-chip', { 'checked' : isAll}]"
                   @click="getBoard('ALL','')" @keypress="getBoard('ALL','')">
                <div class="mdc-chip__ripple"></div>
                <i v-if="isAll"
                   class="material-icons mdc-chip__icon mdc-chip__icon--leading mgr-2 t-color-red">check</i>
                <span role="gridcell">
                  <span class="mdc-chip__text t-body4 font-r">{{ $t('3117') }}</span>
                </span>
              </div>
              <div v-for="(board) in categoryList.boardCategory?categoryList.boardCategory.childCategory:''"
                   :key="board.id + '-name'"
                   class="mdc-chip"
                   role="row" tabindex="0" v-bind:class="['mdc-chip', { 'checked' :ischecked(board.id)}]"
                   @click="getBoard(board.id)" @keypress="getBoard(board.id)">
                <div class="mdc-chip__ripple"></div>
                <i v-if="ischecked(board.id)"
                   class="material-icons mdc-chip__icon mdc-chip__icon--leading mgr-2 t-color-red">check</i>
                <span role="gridcell">
                  <span class="mdc-chip__text  t-body4 font-r">{{ board ? board.name : '' }}</span>
                </span>
              </div>
            </div>
          </div>
          <div v-if="suggestionBox === true" class="recent-search">
            <div v-if="storeSearch && storeSearch.length > 0" class="pda-16 t-body3 t-color-bodyGrayA font-r">
              {{ $t('3127') }}
            </div>
            <div class="community-search-list search-history">
              <div v-for="(searchData,k) in storeSearch" :key="k.id" class="pdl-16 pdr-16 pdt-12 pdb-12">
                <div class="d-flex align-items-center justify-content-between search-list">
                  <div class="d-flex ">
                    <i class="material-icons t-color-iconInactive pdr-8 t-line-h-29">history</i>
                    <div class="t-body3 font-r" tabindex="0" @click="setValueInSearch(searchData)" @keypress="setValueInSearch(searchData)">{{ searchData }}
                    </div>
                  </div>
                  <div class="cursor-pointer" tabindex="0" @click="removeRecentSeachValue(k)" @keypress="removeRecentSeachValue(k)">
                    <i class="material-icons t-color-iconInactive">close</i></div>
                </div>
              </div>
            </div>
          </div>
          <div
              v-if="isAllHide === false"
              class="pdl-16 position-relative mdc-menu-anchor menu-container cursor-pointer header-toggle d-flex justify-content-end mgb-48">
            <button class="mdc-button t-color-bodyGrayA mdc-button-dk js--dropdown-toggle" @click="toggleMenu" >
              <div class="mdc-button__ripple"></div>
              <span class="mdc-button__label t-body3 font-r">{{ menuTypeTitle }}</span>
              <i aria-hidden="true" class="material-icons mdc-button__icon">arrow_drop_down</i>
            </button>
            <div class="mdc-menu mdc-menu-surface toggle-menu more_box">
              <ul aria-hidden="true" aria-orientation="vertical" class="mdc-list" role="menu" tabindex="-1">
                <li class="mdc-list-item" role="menuitem" tabindex="0" @click="onSelect('ALL','3119')" @keypress="onSelect('ALL','3119')">
                  <span class="mdc-list-item__ripple"></span>
                  <span class="mdc-list-item__text t-body6 font-r">{{ $t('3119') }}</span>
                </li>
                <li class="mdc-list-item" role="menuitem" tabindex="0" @click="onSelect('MINE','3120')" @keypress="onSelect('MINE','3120')">
                  <span class="mdc-list-item__ripple"></span>
                  <span class="mdc-list-item__text t-body6 font-r">{{ $t('3120') }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="toggle-menu-scrim d-none" @click="menuActivate" @keypress="menuActivate"></div>
          <NoData v-if="isNoData && suggestionBox === false" :contents="contents" :filterCategory="selectBoardCategory"
                  :selectedMenuType="selectedMenuType" class=""></NoData>

          <div v-if="suggestionBox === false" class="mgb-50 mgt-40">
            <!-- 상단 고정 게시물 -->
            <div v-if="fixListDataList === false && permissionAccess === true">
              <board-list-component v-for="(boardData, index) in fixListData" :key="index" :componentKey="index" :boardData="boardData"></board-list-component>
            </div>

            <!-- 일반 게시물 -->
            <board-list-component v-for="(boardData, index) in listData" 
              :key="index" 
              :componentKey="index" 
              :boardData="boardData" 
              :type="selectedMenuType === 'MINE' ? 'MINE' : ''">
            </board-list-component>
          </div>

          <infinite-loading :identifier="infiniteId" spinner="spiral" @infinite="fetchData">
            <div slot="no-more" class="mgt-16 d-none"></div>
            <div slot="no-results" class="mgt-16 d-none"></div>
          </infinite-loading>

        </div>
      </main>

    </div>

    <div v-if="selectedChild && selectedChild.register === true && isAllHide === false"
         class="fixed-bottom-icon bg-mainBtn shadow1" tabindex="0" @click="goToWrite()" @keypress="goToWrite()">
      <i class="material-icons t-color-white">create</i>
    </div>

  </div>

</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import {topAppBarMixin} from "../../mixins/topAppBar.js";

import boardApi from '@/api/boardApi.js'
import NoData from '../common/NoDataBoard.vue'
import BoardComponent from "@/components/common/BoardComponent";

import InfiniteLoading from 'vue-infinite-loading'

import {mapActions, mapState} from 'vuex'
import {MDCMenu} from "@material/menu";

export default {
  components: {
    InfiniteLoading,
    TopAppBar,
    TopAppBarDrawer,
    NoData,
    'board-list-component': BoardComponent
  },

  data() {
    return {
      status: '',
      isAll: true,
      isAllHide: false,
      isNoData: false,
      isDrawerOpen: false,
      fixListDataList: false,
      permissionAccess: false,
      campaignData: null,
      mamberData: null,
      userAuthData: null,
      selectedChild: null,
      listData: [],
      listData1: [],
      fixListData: [],
      selectedBoard: [],
      selectBoardCategory: null,
      filterCategory: null,
      categoryList: '',
      boardId: null,
      boardName: null,
      headerBoardName: null,
      categoryName: null,
      contents: '',
      menuBar: null,
      menuTypeTitle: this.$t('3119'),
      selectedMenuType: 'ALL',
      showing: {'display': 'flex'},
      hiding: {'display': 'none'},
      suggestionBox: false,
      storeSearch: [],
      currentPage: 1,
      totalPages: 1,
      infiniteId: +new Date(),
      firstCharOfNames: localStorage.getItem('firstChar'),
      bgColorOfName: localStorage.getItem('bgColors'),
    }
  },

  mixins: [topAppBarMixin],

  computed: {
    ...mapState({
      userAuthDetail: state => state.board.userAuthDetail,
    }),

    uniqueCategory() {
      let temp = []
      this.listData1.forEach(item => {
        item.boardDto.boardCategory.childCategory.forEach(arra => {
          temp.push(arra)
        })
      })
      var flags = [], output = [], l = temp.length, i;
      for (i = 0; i < l; i++) {
        if (flags[temp[i].id]) continue;
        flags[temp[i].id] = true;
        output.push({
          id: temp[i].id,
          name: temp[i].name
        });
      }
      return output;
    }
  },

  watch: {
    $route(to, from) {
      this.boardId = this.$route.params.boardId
      this.boardName = this.categoryList.name
      this.categoryName = this.$route.query.categoryName
      this.selectBoardCategory = null
      this.isAll = true
      this.menuTypeTitle = this.$t('3119')
      this.selectedMenuType = 'ALL'
      this.closeDrawer()
      this.getStaticData()
      this.initData()
      this.userAuth()
      this.getCategoryList()
    }
  },

  mounted() {
    this.boardId = this.$route.params.boardId;
    this.boardName = this.categoryList.name
    this.categoryName = this.$route.query.categoryName;
    this.userAuth()
    this.getStaticData()
    this.getCategoryList()
    this.metarialUIData();
  },

  methods: {
    ...mapActions('board', ['SET_USER_AUTH_DETAIL']),

    initData() {
      this.listData = []
      this.currentPage = 1
      this.totalPages = 1
      this.infiniteId += 1
    },

    metarialUIData() {
      const menuEls = Array.from(document.querySelectorAll('.mdc-menu'));
      menuEls.forEach((menuEl) => {
        this.menuBar = new MDCMenu(menuEl);
        const dropdownToggle = menuEl.parentElement.querySelector('.js--dropdown-toggle');
        dropdownToggle.addEventListener('click', () => {
          this.menuBar.open = !this.menuBar.open;
        });
      });
    },

    toggleMenu(evt) {
      let field = evt.target
          .closest(".header-toggle")
          .querySelector(".more_box");
      field.classList.toggle('mdc-menu-surface--open');
      field.classList.toggle('mdc-menu-surface--is-open-below');
      const toggleBackground = document.querySelector('.toggle-menu-scrim');
      toggleBackground.classList.remove('d-none');
    },

    menuActivate() {
      const toggleBackground = document.querySelector('.toggle-menu-scrim')

      let openedMenubar = document.querySelector(".mdc-menu-surface--open");
      if (openedMenubar) {
        openedMenubar.classList.remove("mdc-menu-surface--open");
      }
      toggleBackground.classList.add('d-none')
    },

    userAuth() {
      //let responseData = null
      boardApi.boardAuth(this.$route.params).then((response) => {
        this.userAuthData = response.data.data;
        boardApi.fetchMember().then(response => {
          this.mamberData = response.data.data;
          let myId = this.mamberData.responsibilityId;
          if (this.userAuthData.authType.value === 'STORE') {
            this.selectedChild = this.userAuthData.authPermission[0];
          } else {
            this.selectedChild = this.userAuthData.authPermission.find(child => child.partId == myId)
          }
        }).catch(err => {
          $state.error();
        });
        this.SET_USER_AUTH_DETAIL(this.userAuthData);
      }).catch((err) => {
        this.$error({content: err.errMsg}).then(() => {
        });
      });
    },

    getCategoryList() {
      boardApi.fetchCategoryList(this.$route.params).then(response => {
        this.categoryList = response.data.data
      }).catch(err => {
        console.log('err=>', err);
      });
    },

    // 화면 상단 고정에 필요한 게시판 목록 조회 API 입니다(get fix list)
    getStaticData() {
      boardApi.fetchFixList(this.boardId).then(response => {
        if (this.contents) {
          if (this.listData.length > 0) {
            this.fixListData = response.data.data;
            if (this.fixListData.length > 0) {
              this.permissionAccess = this.fixListData[0].authPermission[0].access;
            }
          } else {
            this.fixListData = [];
          }
        } else {
          this.fixListData = response.data.data;
          if (this.fixListData.length > 0) {
            this.permissionAccess = this.fixListData[0].authPermission[0].access;
          }
        }
      }).catch(err => {
        console.log('err=>', err);
      });
    },

    // 목록 데이터 로딩(get list data)
    fetchData($state) {
      let responseData = null;
      let params = this.setParams();

      if (this.totalPages >= this.currentPage) {
        boardApi.fetchList(params, this.boardId).then((response) => {
          responseData = response.data.data

          this.listData = this.listData.concat(responseData.content.filter((item) => {
                return item.fixed !== true;
              })
          )

          if (this.selectedMenuType === "ALL") {
            this.getStaticData();
          }

          if (this.selectedMenuType === "MINE") {
            this.listData = responseData.content;
          }

          this.listData1 = this.listData;

          this.currentPage++
          this.totalPages = responseData.totalPages

          if (responseData.content.length) {
            $state.loaded()
          } else {
            $state.complete()
          }

          if (responseData.content.length > 0) {
            this.isNoData = false
            this.filterCategory = ''
          } else {
            this.isNoData = true
            this.filterCategory = ''
          }

        }).catch((err) => {
          $state.error()
        })

      } else {
        $state.complete()
      }
    },

    // 파라미터 설정(set parameter)
    setParams() {
      //console.log('isAll',this.isAll)
      if (this.isAll === true) {
        const params = {
          name: '',
          subject: this.contents,
          contents: this.contents,
          statuses: '',
          type: this.selectedMenuType,
          page: this.currentPage,
          size: 10,
          sort: "id,desc",
        }
        return params

      } else {
        const params = {
          name: '',
          categories: this.selectBoardCategory,
          subject: this.contents,
          contents: this.contents,
          statuses: '',
          type: this.selectedMenuType,
          page: this.currentPage,
          size: 10,
          sort: "id,desc",
        }
        return params
      }

    },

    // Board Category
    getBoard(selectedBoardId) {
      this.selectBoardCategory = selectedBoardId
      if (this.selectBoardCategory === 'ALL') {
        this.filterCategory = ''
        this.isAll = true
        this.fixListDataList = false
      } else {
        this.isAll = false;
        this.fixListDataList = true
        this.filterCategory = this.selectBoardCategory
      }

      this.initData()
      this.getStaticData()
    },

    ischecked(checkecdBoardId) {
      return this.selectBoardCategory === checkecdBoardId;
    },


    // Filter type(ALL,MINE)
    onSelect(type, lang) {
      this.menuTypeTitle = this.$t(lang);
      this.selectedMenuType = type
      this.initData()
      if (this.listData.length > 0) {
        this.getStaticData()
      } else {
        this.fixListData = [];
      }
    },

    searchOpen() {
      this.suggestionBox = true
      this.isAllHide = true
      this.showing = {'display': 'none'};
      this.hiding = {'display': 'flex'};
      this.storeSearch = JSON.parse(localStorage.getItem('datas')).reverse();
    },

    searchClose() {
      this.suggestionBox = false
      this.isAllHide = false
      this.fixListDataList = false
      this.contents = ''
      this.initData()
      //this.$router.go(this.$router.currentRoute)
      this.showing = {'display': 'flex'};
      this.hiding = {'display': 'none'};
    },

    search() {
      this.suggestionBox = false
      this.fixListDataList = true
      this.isAllHide = true
      this.initData();

      this.showing = {'display': 'none'};
      this.hiding = {'display': 'flex'};
      let tempArray = []
      if (this.contents) {
        if (localStorage.getItem('datas')) {
          tempArray = JSON.parse(localStorage.getItem('datas'));
        }
        tempArray.push(this.contents)
        localStorage.setItem('datas', JSON.stringify(tempArray))
      }
    },

    // Recent Serach Suggestion
    getStoreSerach() {
      this.suggestionBox = true
      let charSearch = JSON.parse(localStorage.getItem('datas'))
      let searchResult = charSearch.includes(this.contents);
      if (searchResult === true) {
        this.storeSearch = charSearch;
      } else {
        this.storeSearch = ''
      }
    },

    setValueInSearch(searchData) {
      this.contents = searchData
      this.suggestionBox = false
      this.fixListDataList = true
      this.initData();
      //this.getStaticData();
    },

    // Removed value from Recent Serach Suggestion
    removeRecentSeachValue(index) {
      this.storeSearch.splice(index, 1);
      localStorage.setItem('datas', JSON.stringify(this.storeSearch))
    },

    openDrawer() {
      this.isDrawerOpen = true;
    },
    // Close drawer
    closeDrawer() {
      this.isDrawerOpen = false;
    },

    goToWrite() {
      if (this.userAuthData.userBbsToDayAuth === false) {
        this.$snackOpen({contents: this.$t('3064'), btnDisplayYN: false}).then(() => {
        })
      } else {
        this.$router.push({
          name: 'BoardWrite',
          params: {boardId: this.$route.params.boardId},
          query: this.$route.query
        })
      }
    }
  }
}
</script>
<style scoped>
.swiper-wrapper{
  align-items: center !important;
}
</style>
